module.exports = __webpack_public_path__ + "static/media/AANA2021_Logo_Color_1709044955762.65bd9dca.ai";